const urls = [
  "https://open.spotify.com/embed/playlist/65cRebpJTNaTR0ZXbPYHEV?theme=0",
  "https://open.spotify.com/embed/playlist/3llxeXPVxtCOlykBQ1jLjq?theme=0",
];

export default urls;
